/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, November 11th 2021, 10:56:32 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { FormControl } from "@mui/material";
import { useControlledInput } from "ui-widgets/forms";
import { OSFormInputProps } from "ui-widgets/forms/types";
import {
  APIFormInputErrorWrapper,
  CustomInputValidationErrorWrapper,
  HelperTextInputWrapper,
} from "ui-widgets/forms/FormInputWrappers";
import { DatePicker, DatePickerProps } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import TextField from "@mui/material/TextField";

export type DateFormInputProps<T> = OSFormInputProps<T> &
  Omit<DatePickerProps, "value" | "onChange" | "renderInput"> & {
    parseDate?: (value: any) => string;
  };

export const DateFormInput = <T,>(props: DateFormInputProps<T>) => {
  const {
    field: { onChange, value },
  } = useControlledInput<T>(props);

  return (
    <APIFormInputErrorWrapper {...props}>
      <CustomInputValidationErrorWrapper {...props}>
        <HelperTextInputWrapper helperText={props.helperText}>
          <FormControl>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                {...props}
                label={props.label}
                value={value}
                onChange={(value) => onChange(props.parseDate ? props.parseDate(value) : value)}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </FormControl>
        </HelperTextInputWrapper>
      </CustomInputValidationErrorWrapper>
    </APIFormInputErrorWrapper>
  );
};
